import {
  EventBus,
  BusEvent,
  DispatcherPriority,
  EventBusRegistry
} from './EventBus'

export abstract class Dispatcher<D, M> {
  protected abstract priority: DispatcherPriority

  public constructor(protected dispatcher: EventBus) {}

  // Will consume or only process the event
  protected abstract consumable: boolean

  // Filter event by some criteria
  protected abstract criteria(event: BusEvent<D, M>): boolean

  // All Dispatcher should be able to transform event to notification
  public static eventToNotification(
    _event: BusEvent<unknown, unknown>
  ): unknown {
    return undefined
  }

  public register(fn: (event: BusEvent<D, M>) => void): EventBusRegistry
  public register(
    fn: (event: BusEvent<D, M>) => void,
    priority: DispatcherPriority
  ): EventBusRegistry
  public register(
    fn: (event: BusEvent<D, M>) => void,
    priority?: DispatcherPriority
  ): EventBusRegistry {
    return this.dispatcher.register((event: BusEvent<D, M>) => {
      if (this.criteria(event)) {
        fn(event)
        return this.consumable
      }
      return false
    }, priority ?? this.priority)
  }

  public fire(event: BusEvent<D, M>) {
    this.dispatcher.fire(event)
  }
}
